import React from 'react'
import { Form, Table } from './components'
import usePageWidth from '../../shared/usePageWidth'
import styles from './styles.module.scss'

const Main = () => {
  // без этого оболочка режет колонку контента до 1100 px
  usePageWidth('pageWide')

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>Журнал учета учебных занятий</h1>
        <Form />
        <Table />
      </div>
    </div>
  )
}

export default Main
